import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import AnnouncementsView from 'components/composed/views/AnnouncementsView';
import BusinessSnapshotView from 'components/composed/views/BusinessSnapshotView';
import DeliveryDateView from 'components/composed/views/DeliveryDateView';
import TasksView from 'components/composed/views/TasksView';
import UpcomingDatesView from 'components/composed/views/UpcomingDatesView';

const StyledContainer = styled.div`
  display: grid;
  gap: ${theme.spaces.smallX}px;
  width: 100%;

  > div {
    &:nth-child(1) {
      grid-column-start: 1;
      grid-column-end: 5;
      grid-row-start: 1;
      grid-row-end: 2;
    }

    &:nth-child(2) {
      grid-column-start: 5;
      grid-column-end: 7;
      grid-row-start: 1;
      grid-row-end: 2;
      max-height: 481px;
      width: 360px;
    }

    &:nth-child(3) {
      grid-column-start: 1;
      grid-column-end: 2;
      grid-row-start: 2;
      grid-row-end: 3;
    }

    &:nth-child(4) {
      grid-column-start: 2;
      grid-column-end: 5;
      grid-row-start: 2;
      grid-row-end: 3;
    }

    &:nth-child(5) {
      grid-column-start: 5;
      grid-column-end: 7;
      grid-row-start: 2;
      grid-row-end: 3;
    }
  }

  @media ${theme.devices.tablet} {
    display: block;

    > div {
      margin-bottom: ${theme.spaces.regular}px;

      &:nth-child(2) {
        max-height: unset;
        width: unset;
      }

      &:nth-child(3) {
        display: grid;

        > div {
          &:nth-child(1) {
            grid-column-start: 1;
            grid-column-end: 2;
            grid-row-start: 1;
            grid-column-end: 2;
          }

          &:nth-child(2) {
            grid-column-start: 2;
            grid-column-end: 3;
            grid-row-start: 1;
            grid-column-end: 2;
          }

          &:nth-child(3) {
            grid-column-start: 1;
            grid-column-end: 3;
            grid-row-start: 2;
            grid-column-end: 3;
          }
        }
      }
    }
  }
`;

const BusinessOverviewSection = () => {
  return (
    <StyledContainer>
      <BusinessSnapshotView />
      <AnnouncementsView />
      <DeliveryDateView />
      <TasksView />
      <UpcomingDatesView />
    </StyledContainer>
  );
};

export default BusinessOverviewSection;
